var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container bairun-comment" },
    [
      [
        _c(
          "div",
          [
            _c("span", { staticClass: "divider-title" }, [
              _vm._v("用户评论记录")
            ]),
            _c("el-divider")
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-term" },
          [
            _c(
              "el-form",
              { staticClass: "demo-form-inline", attrs: { inline: true } },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      filterable: "",
                      clearable: "",
                      placeholder: "选择集团"
                    },
                    on: { change: _vm.onChangeStationGroup },
                    model: {
                      value: _vm.searchInfo.stationGroupNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "stationGroupNo", $$v)
                      },
                      expression: "searchInfo.stationGroupNo"
                    }
                  },
                  _vm._l(_vm.stationGroupOptions, function(item) {
                    return _c("el-option", {
                      key: item.stationGroupNo,
                      attrs: {
                        label: item.stationGroupName,
                        value: item.stationGroupNo
                      }
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    attrs: {
                      filterable: "",
                      clearable: _vm.stationTempOptions.length > 1,
                      placeholder: "选择油站"
                    },
                    on: { change: _vm.onInputChange },
                    model: {
                      value: _vm.searchInfo.stationId,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "stationId", $$v)
                      },
                      expression: "searchInfo.stationId"
                    }
                  },
                  _vm._l(_vm.stationTempOptions, function(item) {
                    return _c("el-option", {
                      key: item.ID,
                      attrs: { label: item.stationName, value: item.ID }
                    })
                  }),
                  1
                ),
                _c("el-input", {
                  staticClass: "input-with-select",
                  attrs: { placeholder: "手机/订单号 不限时间", clearable: "" },
                  model: {
                    value: _vm.searchText,
                    callback: function($$v) {
                      _vm.searchText = $$v
                    },
                    expression: "searchText"
                  }
                }),
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "small" },
                    on: { change: _vm.onSearchDateTimeTypeChange },
                    model: {
                      value: _vm.searchDateTimeType,
                      callback: function($$v) {
                        _vm.searchDateTimeType = $$v
                      },
                      expression: "searchDateTimeType"
                    }
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "今日" } }),
                    _c("el-radio-button", { attrs: { label: "昨日" } }),
                    _c("el-radio-button", { attrs: { label: "本周" } }),
                    _c("el-radio-button", { attrs: { label: "本月" } }),
                    _c("el-radio-button", { attrs: { label: "本季" } })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { display: "inline-block" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "开始时间",
                        clearable: false
                      },
                      on: { change: _vm.onCustomDateTimeChange },
                      model: {
                        value: _vm.searchStartTime,
                        callback: function($$v) {
                          _vm.searchStartTime = $$v
                        },
                        expression: "searchStartTime"
                      }
                    }),
                    _vm._v(" - "),
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "结束时间，最大3个月",
                        "picker-options": _vm.endTimePickerOptions,
                        clearable: false
                      },
                      on: { change: _vm.onCustomDateTimeChange },
                      model: {
                        value: _vm.searchEndTime,
                        callback: function($$v) {
                          _vm.searchEndTime = $$v
                        },
                        expression: "searchEndTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                  [_vm._v("查询")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onExport } },
                  [_vm._v("导出差评")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      [
        _c(
          "el-row",
          { attrs: { gutter: 50 } },
          [
            _c("el-col", { attrs: { span: 24 } }, [
              _c(
                "div",
                { staticClass: "bairun-group" },
                [
                  _c(
                    "p",
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: { change: _vm.onSubmit },
                          model: {
                            value: _vm.searchTagType,
                            callback: function($$v) {
                              _vm.searchTagType = $$v
                            },
                            expression: "searchTagType"
                          }
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "全部" } }),
                          _c("el-radio-button", { attrs: { label: "好评" } }),
                          _c("el-radio-button", { attrs: { label: "差评" } }),
                          _c(
                            "el-badge",
                            {
                              attrs: { value: _vm.unHandelTotal + "条未处理" }
                            },
                            [
                              _c("el-radio-button", {
                                staticClass: "comment-tagtype-lastchild",
                                attrs: { label: "差评未处理" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.tableData,
                        stripe: "",
                        "tooltip-effect": "dark",
                        height: "35rem"
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "", width: "50", align: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-avatar", {
                                  attrs: {
                                    size: 40,
                                    icon: "el-icon-user-solid"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "用户", prop: "mobile" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", [_vm._v(_vm._s(scope.row.mobile))]),
                                _c(
                                  "div",
                                  { staticClass: "table-comment-station" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getStationName")(
                                          scope.row.sellerId
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c("div", [
                                  _vm._v(_vm._s(scope.row.commentSourceNo))
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "分数",
                          prop: "commentPoint",
                          width: "160"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-rate", {
                                  attrs: {
                                    disabled: "",
                                    "show-score": "",
                                    "text-color": "#ff9900",
                                    "score-template": "{value}"
                                  },
                                  model: {
                                    value: scope.row.commentPoint,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "commentPoint", $$v)
                                    },
                                    expression: "scope.row.commentPoint"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "标签", prop: "code" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return scope.row.commentTagList &&
                                  scope.row.commentTagList.length > 0
                                  ? _vm._l(scope.row.commentTagList, function(
                                      item
                                    ) {
                                      return _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "warning",
                                            effect: "plain",
                                            size: "small"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.commentTagName))]
                                      )
                                    })
                                  : undefined
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "评论", prop: "commentText" }
                      }),
                      _c("el-table-column", {
                        attrs: { label: "处理结果", prop: "remark" }
                      }),
                      _c("el-table-column", {
                        attrs: { label: "提交时间", prop: "CreatedAt" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDate")(scope.row.CreatedAt)
                                  )
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "处理时间", prop: "UpdatedAt" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatTime")(scope.row.UpdatedAt)
                                  )
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "90" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "div",
                                  [
                                    scope.row.commentStatus === 1
                                      ? _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function($event) {
                                                return _vm.onRemark(scope.row)
                                              }
                                            }
                                          },
                                          [_vm._v("未处理")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    scope.row.commentStatus === 2
                                      ? _c(
                                          "el-link",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.onRemark(scope.row)
                                              }
                                            }
                                          },
                                          [_vm._v("已处理")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function($event) {
                                            return _vm.onViewOrder(
                                              scope.row.commentSourceNo
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("查看订单")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    style: { float: "right", padding: "20px" },
                    attrs: {
                      "current-page": _vm.page,
                      "page-size": _vm.pageSize,
                      "page-sizes": [10, 30, 50, 100],
                      total: _vm.total,
                      layout: "total, sizes, prev, pager, next, jumper"
                    },
                    on: {
                      "current-change": _vm.handleCurrentChange,
                      "size-change": _vm.handleSizeChange
                    }
                  })
                ],
                1
              )
            ])
          ],
          1
        )
      ],
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.dialogVisible,
            title: "评论处理",
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.formData,
                "label-position": "right",
                "label-width": "80px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "bairun-required",
                  attrs: { label: "处理结果:", prop: "remark" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      placeholder: "请备注好处理结果"
                    },
                    model: {
                      value: _vm.formData.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "remark", $$v)
                      },
                      expression: "formData.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.enterDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewDialogVisible,
            title: "订单信息",
            width: "40%"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.viewOrder,
                "label-position": "right",
                "label-width": "80px",
                size: "mini"
              }
            },
            [
              _c("el-form-item", { attrs: { label: "订单号:" } }, [
                _vm._v(_vm._s(_vm.viewOrder.mainOrderNo))
              ]),
              _c("el-form-item", { attrs: { label: "枪号:" } }, [
                _vm._v(_vm._s(_vm.viewOrder.goodsNo) + "号枪")
              ]),
              _c("el-form-item", { attrs: { label: "油品:" } }, [
                _vm._v("#" + _vm._s(_vm.viewOrder.goodsType))
              ]),
              _c("el-form-item", { attrs: { label: "升数:" } }, [
                _vm._v(_vm._s(_vm.viewOrder.goodsNum) + "L")
              ]),
              _c("el-form-item", { attrs: { label: "加油金额:" } }, [
                _vm._v("¥" + _vm._s(_vm.viewOrder.orderSaleAmount))
              ]),
              _c("el-form-item", { attrs: { label: "优惠金额:" } }, [
                _vm._v("¥" + _vm._s(_vm.viewOrder.orderDiscount))
              ]),
              _c("el-form-item", { attrs: { label: "实付金额:" } }, [
                _vm._v("¥" + _vm._s(_vm.viewOrder.tradePay))
              ]),
              _c("el-form-item", { attrs: { label: "支付方式:" } }, [
                _vm._v(_vm._s(_vm.viewOrder.payChannelName))
              ]),
              _c("el-form-item", { attrs: { label: "结算时间:" } }, [
                _vm._v(_vm._s(_vm._f("formatDate")(_vm.viewOrder.CreatedAt)))
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "订单状态:" } },
                [
                  _c("OrderStatusTag", {
                    attrs: {
                      orderStatus: _vm.viewOrder.orderStatus,
                      orderStatusName:
                        _vm.viewOrder.orderStatus == 1
                          ? "已结算"
                          : _vm.filterDict(
                              _vm.viewOrder.orderStatus,
                              "orderStatus"
                            ),
                      refundStatus: _vm.viewOrder.refundStatus,
                      refundStatusName: _vm.filterDict(
                        _vm.viewOrder.refundStatus,
                        "refundStatus"
                      )
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.viewDialogVisible = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }